import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'libs/styled';
import useBreakpoint from '@sportson/core-web/hooks/useBreakpoint';
import { above } from '@sportson/core-web/utils/mediaqueries';
import Text from 'components/Text';
import { Info } from 'assets/media/icons/Info';
import FormatPrice from '@sportson/core-web/components/FormatPrice';

const HoverWrapper = styled('div')`
    position: relative;
`;

const MobileButton = styled('button')``;

const Wrapper = styled('div')`
    display: flex;
    padding: 4px 0;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    gap: 6px;
    text-wrap: nowrap;
    cursor: pointer;
`;

const AbsoluteWrapper = styled('div')`
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    padding: 12px 16px;
    width: 100%;
    border-radius: var(--corner-radius-round, 4px);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);

    background-color: var(--background-color-default);
    opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'collapse')};
    transition: ${({ isOpen }) =>
        isOpen ? 'opacity var(--transition-primary)' : 'opacity var(--transition-primary), visibility 0s .3s'};
    overflow: hidden;

    ${above['tablet.sm']} {
        width: 250px;
    }
`;
export const PriceHistory = ({ label = '', priceHistory, ...rest }) => {
    const { t } = useTranslation();
    const isDesktop = useBreakpoint({ from: 'tablet.sm' });
    const tooltipRef = useRef();
    const [toolTipOpen, setToolTipOpen] = useState(false);
    const price = t('price.with_currency', { price: priceHistory });

    return (
        <HoverWrapper
            ref={tooltipRef}
            onMouseEnter={() => (isDesktop ? setToolTipOpen(true) : null)}
            onMouseLeave={() => (isDesktop ? setToolTipOpen(false) : null)}
            {...rest}
        >
            <MobileButton onClick={() => (!isDesktop ? setToolTipOpen(!toolTipOpen) : null)}>
                <Wrapper>
                    <Info />
                    <Text color="var(--color-neutrals-500)" typography="UI/12_100_0_450">
                        {label}
                    </Text>
                </Wrapper>
            </MobileButton>

            <AbsoluteWrapper aria-hidden={!toolTipOpen} isOpen={toolTipOpen}>
                <FormatPrice
                    isRounded
                    skipDecimals
                    price={priceHistory}
                    vatRate={1}
                    render={(price) => {
                        const priceString = t('price.with_currency', { price });

                        return (
                            <Text $as="p" color="var(--text-color-default)" typography="Content/14_130_0_350">
                                {t('pdp.info.price_history_string', { price: priceString })}
                            </Text>
                        );
                    }}
                />
            </AbsoluteWrapper>
        </HoverWrapper>
    );
};
